import axios from '../axios';
import util from './util';
const apiPath = `${process.env.VUE_APP_API_ENDPOINT}/api/admin/advertisements`;

const api = {
    index: query => {
        return axios.get(`${apiPath}/index?${util.queryToString(query)}`);
    },
    elasticIndex: query => {
        return axios.get(
            `${apiPath}/elastic-index?${util.queryToString(query)}`
        );
    },
    show: id => {
        return axios.get(`${apiPath}/show/${id}`);
    },
    showByProperty: propertyId => {
        return axios.get(`${apiPath}/show-by-property/${propertyId}`);
    },
    showByProject: projectId => {
        return axios.get(`${apiPath}/show-by-project/${projectId}`);
    },
    createPropertyAd: entity => {
        return axios.post(`${apiPath}/create/property`, {
            ...entity
        });
    },
    createProjectAd: entity => {
        return axios.post(`${apiPath}/create/project`, {
            ...entity
        });
    },
    update: (id, entity) => {
        return axios.put(`${apiPath}/update/${id}`, {
            ...entity
        });
    },
    verify: (id, entity) => {
        return axios.put(`${apiPath}/${id}/verify`, {
            ...entity
        });
    },
    deny: (id, entity) => {
        return axios.put(`${apiPath}/${id}/deny`, {
            ...entity
        });
    }
};

export default api;
